import qs from 'qs'
import { PumpShiftFilter } from '../models'
import axiosClient from './axiosClient'

const PATH = '/pump-shifts'

export const pumpShiftApi = {
  getPumpShifts: (pumpShiftFilter: PumpShiftFilter) =>
    axiosClient.get(PATH, {
      params: pumpShiftFilter,
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: 'repeat' }),
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }),

  getPumpShiftById: (id: number) =>
    axiosClient.get(`${PATH}/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }),

  closePumpShift: (id: number) =>
    axiosClient.put(
      `${PATH}/${id}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      }
    ),

  closePumpShiftsByStation: (stationId: number) =>
    axiosClient.put(
      PATH,
      {},
      {
        params: {
          stationId,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      }
    ),
}
